<script setup>
/* global defineProps, defineEmits */
import { computed } from 'vue';
import { statusOptions } from './teamHolidayStatus';

const props = defineProps({
  holiday: { type: Object, required: true },
  employeeName: { type: String, required: true },
  disabled: { type: Boolean, default: false },
  id: { type: String, default: undefined },
});
const emit = defineEmits(['change']);
const options = computed(() => statusOptions(props.holiday));
const statusClasses = { pending: 'holiday-status--pending', approved: 'holiday-status--approved', rejected: 'holiday-status--rejected', cancelled: 'holiday-status--cancelled' };
</script>

<template>
  <el-select :id="id" :model-value="holiday.status" class="team-status w-100" :class="statusClasses[holiday.status]"
    :disabled="disabled || options.length < 2" :aria-label="`Estado de vacaciones de ${employeeName}`" @change="emit('change', $event)">
    <el-option v-for="option in options" :key="option.value" :value="option.value" :label="option.label">
      <span :class="statusClasses[option.value]">{{ option.label }}</span>
    </el-option>
  </el-select>
</template>
